module.exports = __webpack_public_path__ + "img/153.4ea0784d.jpg";